import React from 'react'

export const Header = ({ title }: { title: string }) => (
  <div
    role='cell'
    className='col-12 d-flex justify-content-center align-items-center'
  >
    <div className='mc-py-4 mc-text--left'>
      <span className='mc-text--1-line mc-text-h5'>{title}</span>
    </div>
  </div>
)
